import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import salherimg from "../../assets/images/worldheritage/Salher.jpg";
import Shivneriimg from "../../assets/images/worldheritage/Shivneri.jpg";
import Lohgadimg from "../../assets/images/worldheritage/Lohgad.JPG";
import khanderiimg from "../../assets/images/worldheritage/Khanderi.jpg";
import raigadimg from "../../assets/images/worldheritage/Raigad.JPG";
import rajgadimg from "../../assets/images/worldheritage/Rajgad.jpg";
import pratapgadimg from "../../assets/images/worldheritage/Pratapgad.jpg";
import suvarnadurgaimg from "../../assets/images/worldheritage/Suvarnadurga.JPG";
import panhalaimg from "../../assets/images/worldheritage/Panhala.JPG";
import vijaydurgimg from "../../assets/images/worldheritage/Vijaydurg.jpg";
import sindhudurgimg from "../../assets/images/worldheritage/Sindhudurg .jpg";
import gingeeimg from "../../assets/images/worldheritage/Gingee.JPG";

const Worldheritage = () => {
  const selectedLang = useSelector((state) => state.language.selectedLang);

  const forts = [
    { id: "salher", name: { English: "Salher Fort", मराठी: "साल्हेर किल्ला" }, img: salherimg },
    { id: "shivneri", name: { English: "Shivneri Fort", मराठी: "शिवनेरी किल्ला" }, img: Shivneriimg },
    { id: "lohagad", name: { English: "Lohagad Fort", मराठी: "लोहगड किल्ला" }, img: Lohgadimg },
    { id: "khanderi", name: { English: "Khanderi Fort", मराठी: "खांदेरी किल्ला" }, img: khanderiimg },
    { id: "raigad", name: { English: "Raigad Fort", मराठी: "रायगड किल्ला" }, img: raigadimg },
    { id: "rajgad", name: { English: "Rajgad Fort", मराठी: "राजगड किल्ला" }, img: rajgadimg },
    { id: "pratapgad", name: { English: "Pratapgad Fort", मराठी: "प्रतापगड किल्ला" }, img: pratapgadimg },
    { id: "suvarnadurg", name: { English: "Suvarnadurg Fort", मराठी: "सुवर्णदुर्ग किल्ला" }, img: suvarnadurgaimg },
    { id: "panhala", name: { English: "Panhala Fort", मराठी: "पन्हाळा किल्ला" }, img: panhalaimg },
    { id: "vijaydurg", name: { English: "Vijaydurg Fort", मराठी: "विजयदुर्ग किल्ला" }, img: vijaydurgimg },
    { id: "sindhudurg", name: { English: "Sindhudurg Fort", मराठी: "सिंधुदुर्ग किल्ला" }, img: sindhudurgimg },
    { id: "gingee", name: { English: "Gingee Fort", मराठी: "जिंजी किल्ला" }, img: gingeeimg },
  ];

  const content = {
    English: {
      title: "World Heritage",
      breadcrumb: {
        home: "HOME",
        page: "World Heritage",
      },
    },
    मराठी: {
      title: "जागतिक वारसा",
      breadcrumb: {
        home: "मुख्यपृष्ठ ",
        page: "जागतिक वारसा",
      },
    },
  };

  const t = content[selectedLang];

  return (
    <div className="bg-[#F6F6EC] min-h-screen px-4 py-12">
      {/* Header Section */}
      <div className="text-center mb-12">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {t.breadcrumb.home}
            </Link>{" "}
            /{" "}
          </span>
          {t.breadcrumb.page}
        </p>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-2 sm:grid-cols-4 gap-6">
        {forts.map((fort) => (
          <Link
            key={fort.id}
            to={`/fort/${fort.id}`}
            className="group bg-white rounded-xl border border-[#F8D6BF] overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 p-3 flex flex-col items-center"
          >
            <div className="w-full overflow-hidden rounded-lg">
              <img
                src={fort.img}
                alt={fort.name[selectedLang]}
                className="w-full h-40 object-cover transition-transform duration-300 group-hover:scale-105 rounded-lg"
              />
            </div>
            <p className="mt-3 text-black font-medium text-center">
              {fort.name[selectedLang]}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Worldheritage;
